import {
    SAVE_AP_MODAL_AND_FIRM_DIST_GRAPH,
    AP_MODAL_AND_FIRM_DIST_GRAPH_API_LOADING
} from '../../constants/graphConstants/connectedClientsGraphConstants';

/**
 * Reducer function for managing hiSenese graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const apModalAndFirmwareDistGraphReducer = (state = {
    loading: false, 
    model_counts : {}
}, action) => {
	switch (action.type) {
		case SAVE_AP_MODAL_AND_FIRM_DIST_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case AP_MODAL_AND_FIRM_DIST_GRAPH_API_LOADING:
            return { 
                ...state,
                model_counts :{},
                loading: action.payload, 
            };
		default:
			return state;
	}
};